import {StorageInterface} from './index';
import {LocalStorage} from './localStorage';
import {
  PARTY_ID_KEY,
  PARTY_ID_TTL_DAYS,
  SESSION_ID_KEY,
  SESSION_ID_TTL_DAYS,
  BRAND_ID_KEY,
  BRAND_ID_TTL_DAYS,
  SESSION_LAST_USE_KEY,
  SESSION_LAST_USE_TTL_DAYS,
} from './keys';

/**
 * Copy session-context keys from localStorage into cookie storage, then remove them from
 * localStorage. Called once on first init with a cookieDomain so existing users keep their
 * identifiers when the site switches from localStorage to cookie-based storage.
 */
export function migrateIdsToCookies(cookieStorage: StorageInterface): void {
  let localStore: LocalStorage;
  try {
    localStore = new LocalStorage();
  } catch {
    return;
  }

  const migrate = (key: string, ttl: number) => {
    const value = localStore.get(key);
    if (value !== undefined) {
      // Only copy to the cookie if no shared cookie value exists yet — otherwise
      // this subdomain's stale localStorage value would overwrite the value that
      // another subdomain already wrote to the shared cookie.
      if (cookieStorage.get(key) === undefined) {
        cookieStorage.set(key, value, {expires: ttl});
      }
      try {
        localStore.remove(key);
      } catch {
        // Migration is best-effort; a restricted localStorage must not break SDK init.
      }
    }
  };

  migrate(PARTY_ID_KEY, PARTY_ID_TTL_DAYS);
  migrate(SESSION_ID_KEY, SESSION_ID_TTL_DAYS);
  migrate(BRAND_ID_KEY, BRAND_ID_TTL_DAYS);
  migrate(SESSION_LAST_USE_KEY, SESSION_LAST_USE_TTL_DAYS);
}
